import { EHeadingStyleVariant, Heading, Radio, RadioGroup } from '@outdoorsyco/bonfire';
import React from 'react';
import { Controller, UseFormReturn } from 'react-hook-form';
import { useIntl } from 'react-intl';

import {
  EDeliveryFields,
  EDeliveryOption,
  TDeliveryFields,
} from '@/services/types/core/delivery.types';

import css from './AfterDeliveryOptions.module.css';
import { VoidInsuranceConfirmation } from './VoidInsuranceConfirmation';

export const AfterDeliveryOptions = ({
  form,
  watchStationary,
}: {
  form: UseFormReturn<TDeliveryFields>;
  watchStationary: string;
}) => {
  const intl = useIntl();

  const afterDeliveryInsuranceOptions = {
    [EDeliveryOption.MOVING]: {
      title: intl.formatMessage({
        defaultMessage: 'Yes, we’re hitting the road!',
        id: 'aEjIfb',
      }),
      description: intl.formatMessage({
        defaultMessage: 'Excellent, the host will deliver the rig and have it ready for your trip.',
        id: '82+wZU',
      }),
    },
    [EDeliveryOption.STATIONARY]: {
      title: intl.formatMessage({
        defaultMessage: 'No, we’re staying in one place.',
        id: 'WQCGfM',
      }),
      description: intl.formatMessage({
        defaultMessage:
          'Perfect, the host will deliver the rig and we’ll discount your insurance since you won’t be moving it.',
        id: 'FpYonj',
      }),
    },
  };
  return (
    <div>
      <Heading variant={EHeadingStyleVariant.H3} className="my-2 autoType600 highlight">
        {intl.formatMessage({
          defaultMessage: 'Are you moving the vehicle after it’s delivered?',
          id: 'iiLsfG',
        })}
      </Heading>
      <fieldset className="lg:w-full lg:block">
        <Controller
          control={form.control}
          name={EDeliveryFields.DELIVERY_STATIONARY}
          rules={{
            required: {
              value: true,
              message: intl.formatMessage({
                defaultMessage: 'You are required to select an option.',
                id: 'DaZcPq',
              }),
            },
          }}
          render={({ field: { value, onChange } }) => {
            return (
              <RadioGroup
                aria-label={intl.formatMessage({
                  defaultMessage: 'Are you moving the vehicle after it’s delivered?',
                  id: 'iiLsfG',
                })}
                name={EDeliveryFields.DELIVERY_STATIONARY}
                inputValue={value || ''}
                onChange={onChange}>
                {Object.entries(afterDeliveryInsuranceOptions).map(([key, option]) => {
                  return (
                    <div key={key} className={css.option}>
                      <Radio
                        value={key}
                        ariaLabel={option.title}
                        content={{
                          label: option.title,
                          description: value === key ? option.description : undefined,
                        }}
                      />
                    </div>
                  );
                })}
              </RadioGroup>
            );
          }}
        />

        {watchStationary === EDeliveryOption.STATIONARY && (
          <VoidInsuranceConfirmation form={form} />
        )}
      </fieldset>
    </div>
  );
};
